// @flow
import * as React from 'react'
import './styles.scss'

type Props = {
  clickHandler: () => void
}

export function RatingExplanationButton({ clickHandler }: Props) {
  return (
    <aside className='ui component very fitted basic center aligned segment'>
      <button
        className='ui medium basic secondary button rating-explanation'
        onClick={clickHandler}
      >
        <i className='info circle icon' />
        So wurde bewertet
        <i className='right chevron icon' />
      </button>
    </aside>
  )
}
